/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @name eventsPageDirective
 * @memberOf module:avi/events
 * @property {boolean} transclude
 * @property {module:avi/events.EventsListController} controller
 */
angular.module('avi/events').directive('eventsPage', function() {
    return {
        restrict: 'AE',
        transclude: true,
        scope: true,
        controller: 'EventsListController',
        templateUrl: 'src/views/application/events-list.html',
    };
});
